[
  {
    "year": 2023,
    "region": "AK",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "AK",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "AK",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "AK",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": 6000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": 6000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": 500,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": 500,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": 24999,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": 89999,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.049
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": 24999,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": 89999,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.049
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": 24999,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": 89999,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.049
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": 24999,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": 89999,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.049
  },
  {
    "year": 2023,
    "region": "AZ",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "AZ",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "AZ",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "AZ",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 20839,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 49371,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 63644,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 78765,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 93037,
    "taxRate": 0.08
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 474824,
    "taxRate": 0.093
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 569790,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 949649,
    "taxRate": 0.113
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 20824,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 49368,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 77918,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 108162,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 136700,
    "taxRate": 0.08
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 698274,
    "taxRate": 0.093
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 837922,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 1396542,
    "taxRate": 0.113
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 10412,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 24684,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 38959,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 54081,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 68350,
    "taxRate": 0.08
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 349137,
    "taxRate": 0.093
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 418961,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 698271,
    "taxRate": 0.113
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 10412,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 24684,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 38959,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 54081,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 68350,
    "taxRate": 0.08
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 349137,
    "taxRate": 0.093
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 418961,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 698271,
    "taxRate": 0.113
  },
  {
    "year": 2023,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2023,
    "region": "CO",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "CO",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "CO",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "CO",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 16000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 80000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 160000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 320000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 400000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 800000,
    "taxRate": 0.069
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 100000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 200000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 400000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 500000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.069
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 50000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 200000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.069
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 50000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 200000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.069
  },
  {
    "year": 2023,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 80000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 120000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2023,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2023,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "FL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "FL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "FL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "FL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": 1000,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": 7000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": 1000,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": 7000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": 750,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": 2250,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": 3750,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": 5250,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": 7000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": 750,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": 2250,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": 3750,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": 5250,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": 7000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 3600,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 7200,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 14400,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 21600,
    "taxRate": 0.064
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 28800,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 36000,
    "taxRate": 0.072
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 54000,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 72000,
    "taxRate": 0.079
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 225000,
    "taxRate": 0.0825
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 262500,
    "taxRate": 0.09
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 300000,
    "taxRate": 0.1
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 4800,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 9600,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 19200,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 28800,
    "taxRate": 0.064
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 38400,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 48000,
    "taxRate": 0.072
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 72000,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 96000,
    "taxRate": 0.079
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 300000,
    "taxRate": 0.0825
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 350000,
    "taxRate": 0.09
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 400000,
    "taxRate": 0.1
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 2400,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 4800,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 9600,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 14400,
    "taxRate": 0.064
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 19200,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 24000,
    "taxRate": 0.072
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 36000,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 48000,
    "taxRate": 0.079
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 150000,
    "taxRate": 0.0825
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 175000,
    "taxRate": 0.09
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 200000,
    "taxRate": 0.1
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 2400,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 4800,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 9600,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 14400,
    "taxRate": 0.064
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 19200,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 24000,
    "taxRate": 0.072
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 36000,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 48000,
    "taxRate": 0.079
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 150000,
    "taxRate": 0.0825
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 175000,
    "taxRate": 0.09
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 200000,
    "taxRate": 0.1
  },
  {
    "year": 2023,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": 6000,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": 30000,
    "taxRate": 0.0482
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": 75000,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": 12000,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0482
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": 150000,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": 6000,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": 30000,
    "taxRate": 0.0482
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": 75000,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": 6000,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": 30000,
    "taxRate": 0.0482
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": 75000,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Head of Household",
    "to": 4489,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Married Filing Jointly",
    "to": 8978,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Married Filing Separately",
    "to": 4489,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Single Taxpayers",
    "to": 4489,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ID",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "IL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "IL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "IL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "IL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "IN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "IN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "IN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "IN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Head of Household",
    "to": 15000,
    "taxRate": 0.031
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Head of Household",
    "to": 30000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Married Filing Jointly",
    "to": 30000,
    "taxRate": 0.031
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Married Filing Separately",
    "to": 15000,
    "taxRate": 0.031
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Married Filing Separately",
    "to": 30000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Single Taxpayers",
    "to": 15000,
    "taxRate": 0.031
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Single Taxpayers",
    "to": 30000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "KS",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2023,
    "region": "KY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "KY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "KY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "KY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Head of Household",
    "to": 12500,
    "taxRate": 0.0185
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Head of Household",
    "to": 50000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.0185
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Married Filing Jointly",
    "to": 100000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Married Filing Separately",
    "to": 12500,
    "taxRate": 0.0185
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Married Filing Separately",
    "to": 50000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Single Taxpayers",
    "to": 12500,
    "taxRate": 0.0185
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Single Taxpayers",
    "to": 50000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "LA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2023,
    "region": "MA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 100000,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 125000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 150000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 250000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 150000,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 175000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 225000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 300000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 125000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 150000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 125000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 150000,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": 36750,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": 87100,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": 49050,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": 116100,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": 24500,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": 58050,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": 24500,
    "taxRate": 0.058
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": 58050,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2023,
    "region": "MI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0405
  },
  {
    "year": 2023,
    "region": "MI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0405
  },
  {
    "year": 2023,
    "region": "MI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0405
  },
  {
    "year": 2023,
    "region": "MI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0405
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 41010,
    "taxRate": 0.0535
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 164800,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 270060,
    "taxRate": 0.0785
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 43950,
    "taxRate": 0.0535
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 174610,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 304970,
    "taxRate": 0.0785
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 21975,
    "taxRate": 0.0535
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 87305,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 152485,
    "taxRate": 0.0785
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 30070,
    "taxRate": 0.0535
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 98760,
    "taxRate": 0.068
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 183340,
    "taxRate": 0.0785
  },
  {
    "year": 2023,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 1207,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 2414,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 3621,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 4828,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 6035,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 7242,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 8449,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 1207,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 2414,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 3621,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 4828,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 6035,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 7242,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 8449,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 1207,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 2414,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 3621,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 4828,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 6035,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 7242,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 8449,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 1207,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 2414,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 3621,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 4828,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 6035,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 7242,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 8449,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "MS",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 3600,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 6300,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 9700,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 13000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 16800,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 21600,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 3600,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 6300,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 9700,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 13000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 16800,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 21600,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 3600,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 6300,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 9700,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 13000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 16800,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 21600,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 3600,
    "taxRate": 0.01
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 6300,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 9700,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 13000,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 16800,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 21600,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "NC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "NC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "NC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "NC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": 64950,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": 271450,
    "taxRate": 0.0195
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": 80975,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": 298075,
    "taxRate": 0.0195
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": 40475,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": 149025,
    "taxRate": 0.0195
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": 48475,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": 244825,
    "taxRate": 0.0195
  },
  {
    "year": 2023,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 6900,
    "taxRate": 0.0246
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 35480,
    "taxRate": 0.0351
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 52980,
    "taxRate": 0.0501
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0664
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 7390,
    "taxRate": 0.0246
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 44350,
    "taxRate": 0.0351
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 71460,
    "taxRate": 0.0501
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0664
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 3700,
    "taxRate": 0.0246
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 22170,
    "taxRate": 0.0351
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 35730,
    "taxRate": 0.0501
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0664
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 3700,
    "taxRate": 0.0246
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 22170,
    "taxRate": 0.0351
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 35730,
    "taxRate": 0.0501
  },
  {
    "year": 2023,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0664
  },
  {
    "year": 2023,
    "region": "NH",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NH",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NH",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NH",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 50000,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 70000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 80000,
    "taxRate": 0.0553
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 150000,
    "taxRate": 0.0637
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 50000,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 70000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 80000,
    "taxRate": 0.0553
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 150000,
    "taxRate": 0.0637
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 35000,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 75000,
    "taxRate": 0.0553
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 35000,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.035
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 75000,
    "taxRate": 0.0553
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2023,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 24000,
    "taxRate": 0.043
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 315000,
    "taxRate": 0.047
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 24000,
    "taxRate": 0.043
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 315000,
    "taxRate": 0.047
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 4000,
    "taxRate": 0.017
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 8000,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 12000,
    "taxRate": 0.043
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 157500,
    "taxRate": 0.047
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 5500,
    "taxRate": 0.017
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 11000,
    "taxRate": 0.032
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 16000,
    "taxRate": 0.043
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 210000,
    "taxRate": 0.047
  },
  {
    "year": 2023,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2023,
    "region": "NV",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NV",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NV",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NV",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 12800,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 17650,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 20900,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 32200,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 107650,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 269300,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 1616450,
    "taxRate": 0.0685
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 17150,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 23600,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 27900,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 43000,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 161550,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 323200,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 2155350,
    "taxRate": 0.0685
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 8500,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 11700,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 13900,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 21400,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 80650,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 215400,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 1077550,
    "taxRate": 0.0685
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 8500,
    "taxRate": 0.04
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 11700,
    "taxRate": 0.045
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 13900,
    "taxRate": 0.0525
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 21400,
    "taxRate": 0.055
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 80650,
    "taxRate": 0.06
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 215400,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 1077550,
    "taxRate": 0.0685
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2023,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0369
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0369
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0369
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0369
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0.0025
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.0075
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 7500,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 9800,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 14400,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0.0025
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.0075
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 7500,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 9800,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 14400,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 1000,
    "taxRate": 0.0025
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 2500,
    "taxRate": 0.0075
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 3750,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 4900,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 7200,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 1000,
    "taxRate": 0.0025
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 2500,
    "taxRate": 0.0075
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 3750,
    "taxRate": 0.0175
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 4900,
    "taxRate": 0.0275
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 7200,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 8100,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 20200,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 250000,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 8100,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 20200,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 250000,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 4050,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 10100,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 125000,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 4050,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 10100,
    "taxRate": 0.0675
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 125000,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2023,
    "region": "PA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2023,
    "region": "PA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2023,
    "region": "PA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2023,
    "region": "PA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": 73450,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": 166950,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": 73450,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": 166950,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": 73450,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": 166950,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": 73450,
    "taxRate": 0.0375
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": 166950,
    "taxRate": 0.0475
  },
  {
    "year": 2023,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": 3260,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": 16300,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": 6520,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": 32600,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": 3260,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": 16300,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": 3260,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": 16300,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.065
  },
  {
    "year": 2023,
    "region": "SD",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "SD",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "SD",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "SD",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TX",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TX",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TX",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "TX",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "UT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2023,
    "region": "UT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2023,
    "region": "UT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2023,
    "region": "UT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2023,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 60850,
    "taxRate": 0.0335
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 157150,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 254500,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 75850,
    "taxRate": 0.0335
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 183400,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 279450,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 45400,
    "taxRate": 0.0335
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 110050,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 229550,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 45400,
    "taxRate": 0.0335
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 110050,
    "taxRate": 0.066
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 229550,
    "taxRate": 0.076
  },
  {
    "year": 2023,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2023,
    "region": "WA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "WA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "WA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "WA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 14320,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 28640,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 315340,
    "taxRate": 0.053
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 19090,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 38190,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 420420,
    "taxRate": 0.053
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 14320,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 28640,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 315340,
    "taxRate": 0.053
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 14320,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 28640,
    "taxRate": 0.044
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 315340,
    "taxRate": 0.053
  },
  {
    "year": 2023,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2023,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2023,
    "region": "WY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "WY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "WY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2023,
    "region": "WY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "AK",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "AK",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "AK",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "AK",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": 6000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": 6000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": 500,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": 500,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": 25699,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": 92199,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": 25699,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": 92199,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": 25699,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": 92199,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": 25699,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": 92199,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "AZ",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "AZ",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "AZ",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "AZ",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 21527,
    "taxRate": 0.01
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 51000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 65744,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 81364,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 96107,
    "taxRate": 0.08
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 490493,
    "taxRate": 0.093
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 588593,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 980987,
    "taxRate": 0.113
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 21512,
    "taxRate": 0.01
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 50998,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 80490,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 111732,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 141212,
    "taxRate": 0.08
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 721318,
    "taxRate": 0.093
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 865574,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 1442628,
    "taxRate": 0.113
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 10756,
    "taxRate": 0.01
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 25499,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 40245,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 55866,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 70606,
    "taxRate": 0.08
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 360659,
    "taxRate": 0.093
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 432787,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 721314,
    "taxRate": 0.113
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 10756,
    "taxRate": 0.01
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 25499,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 40245,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 55866,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 70606,
    "taxRate": 0.08
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 360659,
    "taxRate": 0.093
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 432787,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 721314,
    "taxRate": 0.113
  },
  {
    "year": 2024,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2024,
    "region": "CO",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "CO",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "CO",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "CO",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 16000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 80000,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 160000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 320000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 400000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 800000,
    "taxRate": 0.069
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 100000,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 200000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 400000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 500000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.069
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 50000,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 200000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.069
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 50000,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 200000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.069
  },
  {
    "year": 2024,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 80000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 120000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2024,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2024,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "FL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "FL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "FL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "FL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0539
  },
  {
    "year": 2024,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0539
  },
  {
    "year": 2024,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0539
  },
  {
    "year": 2024,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0539
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 3600,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 7200,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 14400,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 21600,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 28800,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 36000,
    "taxRate": 0.072
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 54000,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 72000,
    "taxRate": 0.079
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 225000,
    "taxRate": 0.0825
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 262500,
    "taxRate": 0.09
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 300000,
    "taxRate": 0.1
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 4800,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 9600,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 19200,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 28800,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 38400,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 48000,
    "taxRate": 0.072
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 72000,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 96000,
    "taxRate": 0.079
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 300000,
    "taxRate": 0.0825
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 350000,
    "taxRate": 0.09
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 400000,
    "taxRate": 0.1
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 2400,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 4800,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 9600,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 14400,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 19200,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 24000,
    "taxRate": 0.072
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 36000,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 48000,
    "taxRate": 0.079
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 150000,
    "taxRate": 0.0825
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 175000,
    "taxRate": 0.09
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 200000,
    "taxRate": 0.1
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 2400,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 4800,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 9600,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 14400,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 19200,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 24000,
    "taxRate": 0.072
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 36000,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 48000,
    "taxRate": 0.079
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 150000,
    "taxRate": 0.0825
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 175000,
    "taxRate": 0.09
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 200000,
    "taxRate": 0.1
  },
  {
    "year": 2024,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": 6210,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": 31050,
    "taxRate": 0.0482
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": 12420,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": 62100,
    "taxRate": 0.0482
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": 6000,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": 31050,
    "taxRate": 0.0482
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": 6210,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": 31050,
    "taxRate": 0.0482
  },
  {
    "year": 2024,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Head of Household",
    "to": 2499,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Married Filing Jointly",
    "to": 4999,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Married Filing Separately",
    "to": 2499,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Single Taxpayers",
    "to": 2499,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ID",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.057
  },
  {
    "year": 2024,
    "region": "IL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2024,
    "region": "IL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2024,
    "region": "IL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2024,
    "region": "IL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2024,
    "region": "IN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.031
  },
  {
    "year": 2024,
    "region": "IN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.031
  },
  {
    "year": 2024,
    "region": "IN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.031
  },
  {
    "year": 2024,
    "region": "IN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.031
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Head of Household",
    "to": 23000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Married Filing Jointly",
    "to": 46000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Married Filing Separately",
    "to": 23000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Single Taxpayers",
    "to": 23000,
    "taxRate": 0.052
  },
  {
    "year": 2024,
    "region": "KS",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2024,
    "region": "KY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "KY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "KY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "KY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Head of Household",
    "to": 12500,
    "taxRate": 0.0185
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Head of Household",
    "to": 50000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.0185
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Married Filing Jointly",
    "to": 100000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Married Filing Separately",
    "to": 12500,
    "taxRate": 0.0185
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Married Filing Separately",
    "to": 50000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Single Taxpayers",
    "to": 12500,
    "taxRate": 0.0185
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Single Taxpayers",
    "to": 50000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "LA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "MA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 150000,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 175000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 225000,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 300000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 150000,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 175000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 225000,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 300000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 125000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 150000,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 125000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 150000,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": 39050,
    "taxRate": 0.058
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": 92450,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": 52100,
    "taxRate": 0.058
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": 123250,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": 26050,
    "taxRate": 0.058
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": 61600,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": 26050,
    "taxRate": 0.058
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": 61600,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2024,
    "region": "MI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "MI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "MI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "MI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 39010,
    "taxRate": 0.0535
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 156760,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 256880,
    "taxRate": 0.0785
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 46330,
    "taxRate": 0.0535
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 184040,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 321450,
    "taxRate": 0.0785
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 23165,
    "taxRate": 0.0535
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 92020,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 160725,
    "taxRate": 0.0785
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 31690,
    "taxRate": 0.0535
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 104090,
    "taxRate": 0.068
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 193240,
    "taxRate": 0.0785
  },
  {
    "year": 2024,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 1273,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 2546,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 3819,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 5092,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 6365,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 7638,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 8911,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 1273,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 2546,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 3819,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 5092,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 6365,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 7638,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 8911,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 1273,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 2546,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 3819,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 5092,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 6365,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 7638,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 8911,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 1273,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 2546,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 3819,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 5092,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 6365,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 7638,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 8911,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.048
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "MS",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 30750,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 41000,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 20500,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 20500,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "NC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "NC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "NC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "NC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": 63175,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": 264100,
    "taxRate": 0.0195
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": 78775,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": 289975,
    "taxRate": 0.0195
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": 39375,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": 144975,
    "taxRate": 0.0195
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": 47150,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": 238200,
    "taxRate": 0.0195
  },
  {
    "year": 2024,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 7270,
    "taxRate": 0.0246
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 37400,
    "taxRate": 0.0351
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 55850,
    "taxRate": 0.0501
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0584
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 7790,
    "taxRate": 0.0246
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 46760,
    "taxRate": 0.0351
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 75340,
    "taxRate": 0.0501
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0584
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 3900,
    "taxRate": 0.0246
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 23370,
    "taxRate": 0.0351
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 37670,
    "taxRate": 0.0501
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0584
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 3900,
    "taxRate": 0.0246
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 23370,
    "taxRate": 0.0351
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 37670,
    "taxRate": 0.0501
  },
  {
    "year": 2024,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0584
  },
  {
    "year": 2024,
    "region": "NH",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NH",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NH",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NH",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 50000,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 80000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 150000,
    "taxRate": 0.0553
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 50000,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 80000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 150000,
    "taxRate": 0.0553
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 35000,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 75000,
    "taxRate": 0.0553
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 35000,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 75000,
    "taxRate": 0.0553
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2024,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 24000,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 315000,
    "taxRate": 0.049
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 24000,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 315000,
    "taxRate": 0.049
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 4000,
    "taxRate": 0.017
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 8000,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 12000,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 157500,
    "taxRate": 0.049
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 5500,
    "taxRate": 0.017
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 11000,
    "taxRate": 0.032
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 16000,
    "taxRate": 0.047
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 210000,
    "taxRate": 0.049
  },
  {
    "year": 2024,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2024,
    "region": "NV",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NV",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NV",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NV",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 12800,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 17650,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 20900,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 107650,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 269300,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 1616450,
    "taxRate": 0.0685
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 17150,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 23600,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 27900,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 161550,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 323200,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 2155350,
    "taxRate": 0.0685
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 8500,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 11700,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 13900,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 80650,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 215400,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 1077550,
    "taxRate": 0.0685
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 8500,
    "taxRate": 0.04
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 11700,
    "taxRate": 0.045
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 13900,
    "taxRate": 0.0525
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 80650,
    "taxRate": 0.055
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 215400,
    "taxRate": 0.06
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 1077550,
    "taxRate": 0.0685
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2024,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.035
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0.0025
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.0075
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 7500,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 9800,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 14400,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0.0025
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.0075
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 7500,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 9800,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 14400,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 1000,
    "taxRate": 0.0025
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 2500,
    "taxRate": 0.0075
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 3750,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 4900,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 7200,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 1000,
    "taxRate": 0.0025
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 2500,
    "taxRate": 0.0075
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 3750,
    "taxRate": 0.0175
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 4900,
    "taxRate": 0.0275
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 7200,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 8600,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 21500,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 250000,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 8600,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 21500,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 250000,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 4300,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 10750,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 125000,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 4300,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 10750,
    "taxRate": 0.0675
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 125000,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2024,
    "region": "PA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2024,
    "region": "PA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2024,
    "region": "PA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2024,
    "region": "PA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": 77450,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": 176050,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": 77450,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": 176050,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": 77450,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": 176050,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": 77450,
    "taxRate": 0.0375
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": 176050,
    "taxRate": 0.0475
  },
  {
    "year": 2024,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": 3320,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": 16600,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": 6640,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": 33200,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": 3320,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": 16600,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": 3320,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": 16600,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.064
  },
  {
    "year": 2024,
    "region": "SD",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "SD",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "SD",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "SD",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TX",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TX",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TX",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "TX",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "UT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2024,
    "region": "UT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2024,
    "region": "UT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2024,
    "region": "UT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2024,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 64200,
    "taxRate": 0.0335
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 165700,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 268300,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 79950,
    "taxRate": 0.0335
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 193300,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 294600,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 47900,
    "taxRate": 0.0335
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 116000,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 242000,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 47900,
    "taxRate": 0.0335
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 116000,
    "taxRate": 0.066
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 242000,
    "taxRate": 0.076
  },
  {
    "year": 2024,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2024,
    "region": "WA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "WA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "WA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "WA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 14830,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 29660,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 326540,
    "taxRate": 0.053
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 19770,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 39540,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 435380,
    "taxRate": 0.053
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 14830,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 29660,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 326540,
    "taxRate": 0.053
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 14830,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 29660,
    "taxRate": 0.044
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 326540,
    "taxRate": 0.053
  },
  {
    "year": 2024,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.0236
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 25000,
    "taxRate": 0.0315
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.0354
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.0472
  },
  {
    "year": 2024,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0512
  },
  {
    "year": 2024,
    "region": "WY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "WY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "WY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2024,
    "region": "WY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AK",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AK",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AK",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AK",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": 500,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": 6000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": 500,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": 500,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "AL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": 5500,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": 11000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": 25700,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": 5500,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": 11000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": 25700,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": 5500,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": 11000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": 25700,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": 5500,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": 11000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": 25700,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "AR",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "AZ",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "AZ",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "AZ",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "AZ",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 22173,
    "taxRate": 0.01
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 52530,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 67716,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 83805,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 98990,
    "taxRate": 0.08
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 505208,
    "taxRate": 0.093
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 606251,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": 1010417,
    "taxRate": 0.113
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 22158,
    "taxRate": 0.01
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 52528,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 82904,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 115084,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 145448,
    "taxRate": 0.08
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 742958,
    "taxRate": 0.093
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 891542,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": 1485906,
    "taxRate": 0.113
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 11079,
    "taxRate": 0.01
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 26264,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 41452,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 57542,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 72724,
    "taxRate": 0.08
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 371479,
    "taxRate": 0.093
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 445771,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": 742953,
    "taxRate": 0.113
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 11079,
    "taxRate": 0.01
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 26264,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 41452,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 57542,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 72724,
    "taxRate": 0.08
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 371479,
    "taxRate": 0.093
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 445771,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": 742953,
    "taxRate": 0.113
  },
  {
    "year": 2025,
    "region": "CA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.123
  },
  {
    "year": 2025,
    "region": "CO",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "CO",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "CO",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "CO",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 16000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 80000,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 160000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 320000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 400000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": 800000,
    "taxRate": 0.069
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 16000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 80000,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 160000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 320000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 400000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": 800000,
    "taxRate": 0.069
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 50000,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 200000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.069
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 50000,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 200000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.069
  },
  {
    "year": 2025,
    "region": "CT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0699
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.065
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.085
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.0925
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": 1000000,
    "taxRate": 0.0975
  },
  {
    "year": 2025,
    "region": "DC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 2000,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 5000,
    "taxRate": 0.022
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.039
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 20000,
    "taxRate": 0.048
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 25000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.0555
  },
  {
    "year": 2025,
    "region": "DE",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "FL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "FL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "FL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "FL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "GA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0529
  },
  {
    "year": 2025,
    "region": "GA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0529
  },
  {
    "year": 2025,
    "region": "GA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0529
  },
  {
    "year": 2025,
    "region": "GA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0529
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 14400,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 21600,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 28800,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 36000,
    "taxRate": 0.064
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 54000,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 72000,
    "taxRate": 0.072
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 187500,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 262500,
    "taxRate": 0.079
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 337500,
    "taxRate": 0.0825
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 412500,
    "taxRate": 0.09
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": 487500,
    "taxRate": 0.1
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 19200,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 28800,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 38400,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 48000,
    "taxRate": 0.064
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 72000,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 96000,
    "taxRate": 0.072
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 250000,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 350000,
    "taxRate": 0.079
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 450000,
    "taxRate": 0.0825
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 550000,
    "taxRate": 0.09
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": 650000,
    "taxRate": 0.1
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 9600,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 14400,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 19200,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 24000,
    "taxRate": 0.064
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 36000,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 48000,
    "taxRate": 0.072
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 125000,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 175000,
    "taxRate": 0.079
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 225000,
    "taxRate": 0.0825
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 275000,
    "taxRate": 0.09
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": 325000,
    "taxRate": 0.1
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 9600,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 14400,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 19200,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 24000,
    "taxRate": 0.064
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 36000,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 48000,
    "taxRate": 0.072
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 125000,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 175000,
    "taxRate": 0.079
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 225000,
    "taxRate": 0.0825
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 275000,
    "taxRate": 0.09
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": 325000,
    "taxRate": 0.1
  },
  {
    "year": 2025,
    "region": "HI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.11
  },
  {
    "year": 2025,
    "region": "IA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.038
  },
  {
    "year": 2025,
    "region": "IA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.038
  },
  {
    "year": 2025,
    "region": "IA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.038
  },
  {
    "year": 2025,
    "region": "IA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.038
  },
  {
    "year": 2025,
    "region": "ID",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "ID",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "ID",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "ID",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "IL",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2025,
    "region": "IL",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2025,
    "region": "IL",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2025,
    "region": "IL",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0495
  },
  {
    "year": 2025,
    "region": "IN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "IN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "IN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "IN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Head of Household",
    "to": 23000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Married Filing Jointly",
    "to": 46000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Married Filing Separately",
    "to": 23000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Single Taxpayers",
    "to": 23000,
    "taxRate": 0.052
  },
  {
    "year": 2025,
    "region": "KS",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0558
  },
  {
    "year": 2025,
    "region": "KY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "KY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "KY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "KY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "LA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "LA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "LA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "LA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 150000,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 175000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 225000,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": 300000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 150000,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 175000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 225000,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": 300000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 100000,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 125000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 150000,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": 250000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 1000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 2000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 100000,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 125000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 150000,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": 250000,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "MD",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": 40200,
    "taxRate": 0.058
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": 95150,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": 53600,
    "taxRate": 0.058
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": 126900,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": 26800,
    "taxRate": 0.058
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": 63450,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": 26800,
    "taxRate": 0.058
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": 63450,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "ME",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0715
  },
  {
    "year": 2025,
    "region": "MI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "MI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "MI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "MI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 40100,
    "taxRate": 0.0535
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 161130,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": 270060,
    "taxRate": 0.0785
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 47620,
    "taxRate": 0.0535
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 189180,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": 330410,
    "taxRate": 0.0785
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 32570,
    "taxRate": 0.0535
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 106990,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": 203150,
    "taxRate": 0.0785
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 32570,
    "taxRate": 0.0535
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 106990,
    "taxRate": 0.068
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": 203150,
    "taxRate": 0.0785
  },
  {
    "year": 2025,
    "region": "MN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0985
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 1313,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 2626,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 3939,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 5252,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 6565,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 7878,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": 9191,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 1313,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 2626,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 3939,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 5252,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 6565,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 7878,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": 9191,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 1313,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 2626,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 3939,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 5252,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 6565,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 7878,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": 9191,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 1313,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 2626,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 3939,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 5252,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 6565,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 7878,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": 9191,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "MO",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MS",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "MS",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "MS",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "MS",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": 31700,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": 42200,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": 21100,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": 21100,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "MT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "NC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "NC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "NC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "NC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0425
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": 64950,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": 271450,
    "taxRate": 0.0195
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": 80975,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": 298075,
    "taxRate": 0.0195
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": 40475,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": 149025,
    "taxRate": 0.0195
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": 48475,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": 244825,
    "taxRate": 0.0195
  },
  {
    "year": 2025,
    "region": "ND",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.025
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 3310,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 6480,
    "taxRate": 0.0226
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 21050,
    "taxRate": 0.0322
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 30510,
    "taxRate": 0.0491
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 38740,
    "taxRate": 0.0577
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": 72750,
    "taxRate": 0.0594
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.061
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 6620,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 12960,
    "taxRate": 0.0226
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 42100,
    "taxRate": 0.0322
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 61020,
    "taxRate": 0.0491
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 77480,
    "taxRate": 0.0577
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": 145500,
    "taxRate": 0.0594
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.061
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 3310,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 6480,
    "taxRate": 0.0226
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 21050,
    "taxRate": 0.0322
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 30510,
    "taxRate": 0.0491
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 38740,
    "taxRate": 0.0577
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": 72750,
    "taxRate": 0.0594
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.061
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 3310,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 6480,
    "taxRate": 0.0226
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 21050,
    "taxRate": 0.0322
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 30510,
    "taxRate": 0.0491
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 38740,
    "taxRate": 0.0577
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": 72750,
    "taxRate": 0.0594
  },
  {
    "year": 2025,
    "region": "NE",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.061
  },
  {
    "year": 2025,
    "region": "NH",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NH",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NH",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NH",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 35000,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 40000,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 75000,
    "taxRate": 0.0553
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 50000,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 80000,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 150000,
    "taxRate": 0.0553
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 35000,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 75000,
    "taxRate": 0.0553
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 20000,
    "taxRate": 0.014
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 35000,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 75000,
    "taxRate": 0.0553
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 500000,
    "taxRate": 0.0637
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": 1000000,
    "taxRate": 0.0897
  },
  {
    "year": 2025,
    "region": "NJ",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.1075
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 24000,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": 315000,
    "taxRate": 0.049
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 24000,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": 315000,
    "taxRate": 0.049
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 24000,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": 315000,
    "taxRate": 0.049
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 8000,
    "taxRate": 0.017
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 16000,
    "taxRate": 0.032
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 24000,
    "taxRate": 0.047
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": 315000,
    "taxRate": 0.049
  },
  {
    "year": 2025,
    "region": "NM",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.059
  },
  {
    "year": 2025,
    "region": "NV",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NV",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NV",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NV",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 12800,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 17650,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 20900,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 107650,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 269300,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 1616450,
    "taxRate": 0.0685
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 17000,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 23400,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 27800,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 161550,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 430800,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 2155350,
    "taxRate": 0.0685
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 10000000,
    "taxRate": 0.0965
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": 30000000,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 8500,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 11700,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 13900,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 80650,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 215400,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 1077550,
    "taxRate": 0.0685
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 8500,
    "taxRate": 0.04
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 11700,
    "taxRate": 0.045
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 13900,
    "taxRate": 0.0525
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 80650,
    "taxRate": 0.055
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 215400,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 1077550,
    "taxRate": 0.0685
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 5000000,
    "taxRate": 0.0965
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": 25000000,
    "taxRate": 0.103
  },
  {
    "year": 2025,
    "region": "NY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.109
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 46100,
    "taxRate": 0.0277
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 92150,
    "taxRate": 0.0323
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": 115300,
    "taxRate": 0.0369
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0399
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 46100,
    "taxRate": 0.0277
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 92150,
    "taxRate": 0.0323
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": 115300,
    "taxRate": 0.0369
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0399
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 46100,
    "taxRate": 0.0277
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 92150,
    "taxRate": 0.0323
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": 115300,
    "taxRate": 0.0369
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0399
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 26050,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 46100,
    "taxRate": 0.0277
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 92150,
    "taxRate": 0.0323
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": 115300,
    "taxRate": 0.0369
  },
  {
    "year": 2025,
    "region": "OH",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0399
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 2000,
    "taxRate": 0.0025
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.0075
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 7500,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 9800,
    "taxRate": 0.0275
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": 14400,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 2000,
    "taxRate": 0.0025
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.0075
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 7500,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 9800,
    "taxRate": 0.0275
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": 14400,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 1000,
    "taxRate": 0.0025
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 2500,
    "taxRate": 0.0075
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 3750,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 4900,
    "taxRate": 0.0275
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": 7200,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 1000,
    "taxRate": 0.0025
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 2500,
    "taxRate": 0.0075
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 3750,
    "taxRate": 0.0175
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 4900,
    "taxRate": 0.0275
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": 7200,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "OK",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 8800,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 22200,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": 250000,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 8800,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 22200,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": 250000,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 4400,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 11100,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": 125000,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 4400,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 11100,
    "taxRate": 0.0675
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": 125000,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "OR",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.099
  },
  {
    "year": 2025,
    "region": "PA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2025,
    "region": "PA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2025,
    "region": "PA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2025,
    "region": "PA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0307
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": 79900,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": 181650,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": 79900,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": 181650,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": 79900,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": 181650,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": 79900,
    "taxRate": 0.0375
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": 181650,
    "taxRate": 0.0475
  },
  {
    "year": 2025,
    "region": "RI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0599
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": 17830,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": 17830,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": 17830,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": 17830,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "SC",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.06
  },
  {
    "year": 2025,
    "region": "SD",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "SD",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "SD",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "SD",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TN",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TN",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TN",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TN",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TX",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TX",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TX",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "TX",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "UT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2025,
    "region": "UT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2025,
    "region": "UT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2025,
    "region": "UT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0455
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 3000,
    "taxRate": 0.02
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 5000,
    "taxRate": 0.03
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": 17000,
    "taxRate": 0.05
  },
  {
    "year": 2025,
    "region": "VA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0575
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 3825,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 53225,
    "taxRate": 0.0335
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 123525,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": 253525,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 11475,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 93975,
    "taxRate": 0.0335
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 210925,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": 315475,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 3825,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 53225,
    "taxRate": 0.0335
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 123525,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": 253525,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 3825,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 53225,
    "taxRate": 0.0335
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 123525,
    "taxRate": 0.066
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": 253525,
    "taxRate": 0.076
  },
  {
    "year": 2025,
    "region": "VT",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0875
  },
  {
    "year": 2025,
    "region": "WA",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "WA",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "WA",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "WA",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 14680,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 29370,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": 323290,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 19090,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 38190,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": 420420,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 14680,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 29370,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": 323290,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 14680,
    "taxRate": 0.035
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 29370,
    "taxRate": 0.044
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": 323290,
    "taxRate": 0.053
  },
  {
    "year": 2025,
    "region": "WI",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0765
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 10000,
    "taxRate": 0.0222
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 25000,
    "taxRate": 0.0296
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 40000,
    "taxRate": 0.0333
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": 60000,
    "taxRate": 0.0444
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0.0482
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 10000,
    "taxRate": 0.0222
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 25000,
    "taxRate": 0.0296
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 40000,
    "taxRate": 0.0333
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": 60000,
    "taxRate": 0.0444
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0.0482
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 10000,
    "taxRate": 0.0222
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 25000,
    "taxRate": 0.0296
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 40000,
    "taxRate": 0.0333
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": 60000,
    "taxRate": 0.0444
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0.0482
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 10000,
    "taxRate": 0.0222
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 25000,
    "taxRate": 0.0296
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 40000,
    "taxRate": 0.0333
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": 60000,
    "taxRate": 0.0444
  },
  {
    "year": 2025,
    "region": "WV",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0.0482
  },
  {
    "year": 2025,
    "region": "WY",
    "filingStatus": "Head of Household",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "WY",
    "filingStatus": "Married Filing Jointly",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "WY",
    "filingStatus": "Married Filing Separately",
    "to": null,
    "taxRate": 0
  },
  {
    "year": 2025,
    "region": "WY",
    "filingStatus": "Single Taxpayers",
    "to": null,
    "taxRate": 0
  }
]